import { Component, inject, OnInit } from '@angular/core';
import { environment } from '$env/environment';
import { GIT_HASH_TOKEN } from '$core/util/build-info';

@Component({
  selector: 'app-footer-copyright',
  templateUrl: './footer-copyright.component.html',
  styleUrls: ['./footer-copyright.component.scss'],
})
export class FooterCopyrightComponent implements OnInit {
  private readonly gitHash = inject(GIT_HASH_TOKEN);

  protected readonly buildInfo = `v${environment.version} (${this.gitHash})`;

  constructor() {}

  public ngOnInit() {}
}
